import React, { useState } from "react";
import { BaseButtons, CloseButton, TextInputField } from "../atoms";
import { BlackAndWhite } from "../../themes/Colors";
import QuestionButton from "../../modules/customer-portal/components/medical-history/components/button/QuestionButton";
import QuestionaireDropDown from "../../modules/customer-portal/components/medical-history/components/questionaire-drop-down/QuestionareDropDown";

const InvestorForm = ({
  onCloseClick,
  firstName,
  lastName,
  idNumber,
  email,
  password,
  onFirstNameChange,
  onLastNameChange,
  onIdNumChange,
  onEmailChange,
  isBussinesClick,
  onSubmitClick,
  onPasswordChange,
  onAccountNameChange,
  setProvince,
  province,
  onCellChange,
}) => {
  const [confirmPassword, setConfirmPassword] = useState("none");
  return (
    <div
      style={{
        height: "100%",
        width: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          height: "100%",
          width: "100%",
          display: "flex",
          alignItems: "flex-end",
        }}
      >
        <div
          style={{
            flex: 0.7,
            height: "100%",
            position: "relative",
            display: "flex",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              width: "50%",
              height: "100%",
            }}
          >
            <TextInputField
              labelTitle={"First name:"}
              invert={true}
              value={firstName}
              onChange={onFirstNameChange}
              mini={true}
            />
            <div style={{ height: 10 }} />
            <TextInputField
              labelTitle={"Last name:"}
              invert={true}
              value={lastName}
              onChange={onLastNameChange}
              mini={true}
            />
            <div style={{ height: 10 }} />
            <div style={{ position: "relative" }}>
              <TextInputField
                labelTitle={"Id-Num / Passport:"}
                invert={true}
                onChange={onIdNumChange}
                value={idNumber}
                mini={true}
              />
            </div>
            <div style={{ height: 10 }} />
            <TextInputField
              labelTitle={"Email:"}
              invert={true}
              onChange={onEmailChange}
              value={email}
              mini={true}
            />
            <div style={{ height: 10 }} />
            <TextInputField
              labelTitle={"Cell number:"}
              invert={true}
              onChange={onCellChange}
              mini={true}
            />
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              width: "50%",
              height: "100%",
            }}
          >
            <div
              style={{
                position: "relative",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div style={{ marginBottom: 15 }}>Select a province:</div>
              <QuestionButton
                title={
                  province === "none"
                    ? "Click here to select Province"
                    : province
                }
                width={280}
                height={60}
                borderRadius={4}
                backgroundColor={BlackAndWhite.primary}
                borderOn={true}
                color={BlackAndWhite.secondary}
                onClick={
                  province === "none"
                    ? () => setProvince("")
                    : () => setProvince("")
                }
              />
              <div
                style={{
                  position: "absolute",
                  top: -125,
                  width: province === "" ? 300 : 0,
                  left: -15,
                  zIndex: 100,
                  overflow: "hidden",
                  height: province === "" ? null : 0,
                  transition: "width 0.5s",
                  backgroundColor: BlackAndWhite.primary,
                  borderRadius: 10,
                  paddingBottom: 10,
                }}
              >
                <QuestionaireDropDown
                  setItem={setProvince}
                  width={250}
                  height={30}
                  data={[
                    { text: "Gauteng" },
                    { text: "Eastern Cape" },
                    { text: "Free State" },
                    { text: "KwaZulu-Natal" },
                    { text: "Limpopo" },
                    { text: "Mpumalanga" },
                    { text: "Northern Cape" },
                    { text: "North West" },
                    { text: "Western Cape" },
                  ]}
                />
              </div>
            </div>
            <div style={{ height: 10 }} />
            <TextInputField
              labelTitle={"Account Num:"}
              invert={true}
              onChange={onAccountNameChange}
              mini={true}
            />
            <div style={{ height: 10 }} />
            <TextInputField
              labelTitle={"Password:"}
              value={password}
              invert={true}
              onChange={onPasswordChange}
              mini={true}
            />
            <div style={{ height: 10 }} />
            <TextInputField
              labelTitle={"Confirm password:"}
              invert={true}
              onChange={(e) => setConfirmPassword(e.target.value)}
              mini={true}
            />
          </div>
          <div style={{ position: "absolute", top: 20, left: 20 }}>
            <CloseButton label={"X"} onClick={onCloseClick} />
          </div>
        </div>
        <div
          style={{
            flex: 0.3,
            backgroundColor: BlackAndWhite.primary,
            borderTopLeftRadius: 20,
            height: "99%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "center",
          }}
        >
          <div
            style={{
              width: "100%",
              height: 60,
              display: "flex",
              fontSize: 22,
              alignItems: "center",
              color: BlackAndWhite.secondary,
            }}
          >
            <div style={{ marginLeft: 20 }}>Create a Owner</div>
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              alignItems: "center",
              color: BlackAndWhite.secondary,
            }}
          >
            <div style={{ width: "80%", textAlign: "left", marginTop: 20 }}>
              1. Please fill out all the information on the left starting with
              first name.
            </div>
            <div style={{ width: "80%", textAlign: "left", marginTop: 20 }}>
              2. Make sure the email address is correct as the invite for the
              User will be sent to them.
            </div>

            <BaseButtons
              label={"SUBMIT"}
              disable={
                firstName.length >= 2 &&
                lastName.length >= 2 &&
                email.length >= 6 &&
                confirmPassword === password
                  ? false
                  : true
              }
              invert={true}
              onClick={onSubmitClick}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvestorForm;
